import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

import { defaultPaperValues, paperSchema } from '../../Paper/model/PaperSchema';

export const abstractSchema = paperSchema.extend({
  conference: identitySchema.nullable(),
  volumeIsbn: z.string().nullable(),
  authors: z.array(authorSchema).min(1),
});

export const defaultAbstractValues: DefaultValues<AbstractSchema> = {
  ...defaultPaperValues,
  conference: null,
  volumeIsbn: '',
  authors: [],
};

export type AbstractSchema = z.infer<typeof abstractSchema>;
